import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-filter-chips',
  templateUrl: './filter-chips.component.html',
  styleUrls: ['./filter-chips.component.css']
})
export class FilterChipsComponent {

  
  @Input() filters: { [key: string]: string } = {};
  @Output() removeFilter = new EventEmitter<string>();
  @Output() clearAll = new EventEmitter<void>();

  get activeFilters(): { key: string, value: string }[] {
    return Object.entries(this.filters)
      .filter(([_, value]) => value)
      .map(([key, value]) => ({ key, value }));
  }
  
  onRemove(key: string): void {
    this.removeFilter.emit(key);
  }

  onClearAll(): void {
    this.clearAll.emit();
  }
}
